"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonBlank = exports.uuid = exports.date = exports.dateTime = void 0;
/**
 * Predefined string format options used by all 'date-time' formatted strings.
 */
exports.dateTime = {
    example: '2021-10-19T12:12:41.376Z',
    format: 'date-time',
};
/**
 * Predefined string format options used by all 'date' formatted strings.
 */
exports.date = {
    example: '2021-10-19',
    format: 'date',
};
/**
 * Predefined string format options used by all 'uuid' formatted strings.
 */
exports.uuid = {
    example: '4014ba21-0caa-47a1-8dc1-3475e460a03f',
    format: 'uuid',
};
/**
 * Predefined string format options mandating that a string contains non-whitespace characters.
 */
exports.nonBlank = {
    pattern: '^.*\\S.*$',
};
//# sourceMappingURL=string.js.map